import { CITY_SOURCES as SOURCES } from '../history/sources';

/** The medieval names distinguish the chapels from churches and institutions founded later. */
export const CHURCH_STOPS = [
  {
    id: 'landmark-nieuwe-kerk',
    text: 'Why does one town need two great churches? Amsterdam outgrew the Oude Kerk, so a second parish church was approved in 1408. Look up at the crossing: the small roof turret belongs to this medieval skyline.',
    source: SOURCES.newChurch.url,
  },
  {
    id: 'landmark-onze-lieve-vrouwekapel',
    text: 'Not every place of worship needs a great tower. Find this narrow chapel among the Nieuwendijk houses. Anthonisz’s painting helps us put it back in the street; its hidden details and exact position remain a reconstruction.',
    source: SOURCES.map.url,
  },
  {
    id: 'landmark-sint-olofskapel',
    text: 'At the edge of town, travellers meet a chapel beside the old gate. Pilgrims also visited its Jerusalem chapel. Look for the small adjoining roofs: this is the medieval complex, before the seventeenth-century rebuilding.',
    source: SOURCES.olof.url,
  },
  {
    id: 'landmark-oude-kerk',
    text: 'Sailors had a patron saint: Sint Nicolaas. This church was consecrated to him in 1306. Find its tower among the harbour houses, then compare the broad church roof with the little chapels on our route.',
    source: SOURCES.oldChurch.url,
  },
  {
    id: 'landmark-paulusbroederskapel',
    text: 'This is the Paulusbroeders’ chapel, consecrated in 1496. It belongs to their convent in 1538. The name Waalse Kerk comes later, when French-speaking Protestants use it after 1578. Which name belongs in our town register today?',
    source: SOURCES.paulus.url,
  },
  {
    id: 'landmark-sint-pieterskapel',
    text: 'Who cares for you when you have no family nearby? Here on the Nes, the Sint Pietersgasthuis offers meals, shelter and care. Its chapel belongs to the same community. Look for the courtyard workers: a little city within the city, with bread and linen to carry.',
    source: SOURCES.gasthuisLife.url,
  },
  {
    id: 'landmark-agnietenkapel',
    text: 'This chapel dates from 1470 and belongs to a women’s convent. In 1538 it is a place of prayer. The teaching that will make this building part of Amsterdam’s university story lies almost a century ahead.',
    source: SOURCES.agnieten.url,
  },
  {
    id: 'landmark-heilige-stede',
    text: 'Why do pilgrims come here? People believed that a consecrated wafer survived a fire in 1345. A chapel rose at the Heilige Stede, and travellers came along the Heiligeweg. Their belief brought both worship and trade to Amsterdam.',
    source: SOURCES.miracle.url,
  },
  {
    id: 'landmark-begijnhofkapel',
    text: 'The beguines live a religious life while keeping their own possessions and helping others. Their chapel stands in a court surrounded by water. In 1538 this is their medieval church; it will only become the Engelse Kerk in 1607.',
    source: SOURCES.beguines.url,
  },
] as const;
